
import { GET_TRENDING_FURNITURE_DATA, GET_DYNAMIC_BANNER_DATA } from '~/api/apolloAllFurniturePageQueries';

export default {
  name: 'AllFurniturePage',
  data() {
    return {
      loadingFurniture: false,
      trendingFurnitureData: [],
      dynamicBannerData: [],
      loading: true,
    };
  },
  async fetch() {
    await this.getTrendingFurnitureData();
  },
  methods: {
    async getTrendingFurnitureData() {
      try {
        this.loading = true;
        const { allFurniture } = await this.$graphql.default.request(GET_DYNAMIC_BANNER_DATA)
        || {};
        const { trendingFurniture } = await this.$graphql.default.request(GET_TRENDING_FURNITURE_DATA)
        || {};

        if (allFurniture?.dynamicBanner) {
          const filteredBanners = allFurniture?.dynamicBanner?.center?.filter((banner) => banner?.displayPage === 'all-furniture');
          this.dynamicBannerData = filteredBanners.map((banner) => {
            if (banner?.background !== null) {
              return {
                ...banner,
                content: {
                  html: banner.content.html
                    .replace('{{BACKGROUND}}', banner?.background?.banner ?? '')
                    .replace('{{VIDEO}}', banner?.background?.video ?? '')
                    .replace('{{ALT}}', banner?.background?.alt ?? '')
                    .replace('{{ALT}}', banner?.background?.alt ?? ''),
                  style: banner.content.style,
                },
              };
            }
            return banner;
          });
          this.loading = false;
        }
        if (trendingFurniture) {
          this.trendingFurnitureData = trendingFurniture;
        }
      } catch (error) {
        console.error('Error fetching trending furniture data:', error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    breadcrumbs() {
      const breadcrumbs = [...(this.$store.state.metaData?.addons?.breadcrumbs || [])];
      if (breadcrumbs[0]) {
        breadcrumbs[0] = { ...breadcrumbs[0], isInternal: true };
      }
      return breadcrumbs;
    },
  },
};
